import React from 'react';
import { Box } from '@mui/material';
import ComprobanteTypesDashboard from '../../components/accounting/ComprobanteTypesDashboard';

const TiposComprobantePage = () => {  

  return (
    <Box sx={{ p: 2 }}>
      <ComprobanteTypesDashboard
        onReorder={(newOrder) => {
          console.log('Nuevo orden de tipos de comprobante:', newOrder);
        }}
      />
    </Box>
  );
};

export default TiposComprobantePage;